import { format, parseISO } from 'date-fns';
import { getClosedStatusLabel } from './getClosedStatusLabel';

export function translateUnitStatusBasic(
  propertyTypeCode: string,
  statusCode: string,
  closeDate: string | null | undefined
): string {
  if (statusCode === 'CS' || statusCode === 'R') {
    return `${getClosedStatusLabel(propertyTypeCode, statusCode)} ${
      closeDate ? format(parseISO(closeDate), 'MM-dd-yyyy') : ''
    }`;
  } else if (
    statusCode === 'C' ||
    statusCode === 'X' ||
    statusCode === 'T' ||
    statusCode === 'W' ||
    statusCode === 'Q'
  ) {
    return `Off market`;
  } else if (statusCode === 'PS') {
    return `Pending sale`;
  } else if (propertyTypeCode !== 'R' && statusCode === 'CSL') {
    return `Coming Soon`;
  } else if (propertyTypeCode !== 'R' && statusCode === 'AC') {
    return `Accepting Backups`;
  } else if (propertyTypeCode !== 'R' && statusCode === 'A') {
    return `For sale`;
  } else if (
    (propertyTypeCode === 'R' && statusCode === 'A') ||
    (propertyTypeCode === 'R' && statusCode === 'AC')
  ) {
    return `For rent`;
  } else {
    return '';
  }
}
